(window.aeOnSectionReady || function (fn) { document.addEventListener('DOMContentLoaded', () => fn(document)); })((sectionRoot) => {
  document.querySelectorAll('[data-ae-reviews-slider]').forEach((slider) => {
    if (slider.dataset.aeBound === 'true') return;
    slider.dataset.aeBound = 'true';
    const viewport = slider.querySelector('[data-ae-reviews-viewport]');
    const track = slider.querySelector('[data-ae-reviews-track]');
    const slides = Array.from(track?.children || []);
    const prev = slider.querySelector('[data-ae-reviews-prev]');
    const next = slider.querySelector('[data-ae-reviews-next]');
    const progress = slider.querySelector('[data-ae-reviews-progress]');
    if (!viewport || !track || !slides.length) return;

    const step = () => {
      const slide = slides[0];
      if (!slide) return viewport.clientWidth;
      const style = getComputedStyle(slide);
      return slide.getBoundingClientRect().width + parseFloat(style.paddingLeft || '0');
    };

    const update = () => {
      const max = viewport.scrollWidth - viewport.clientWidth;
      const ratio = max <= 0 ? 1 : viewport.scrollLeft / max;
      if (progress) {
        const pct = Math.min(100, Math.max(12, ratio * 100));
        progress.style.transform = `scaleX(${pct / 100})`;
      }
      if (prev) prev.disabled = viewport.scrollLeft <= 1;
      if (next) next.disabled = viewport.scrollLeft >= max - 1;
    };

    prev?.addEventListener('click', () => {
      viewport.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    next?.addEventListener('click', () => {
      viewport.scrollBy({ left: step(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    update();
  });
});
